export default {
    siteIdElement: document.querySelector('[data-adv-siteid]'),
    pageIdElement: document.querySelector('[data-adv-pageid]'),
    targetElement: document.querySelector('[data-adv-target]'),
    formatIdElements: document.querySelectorAll('[data-adv-formatid]'),
    adSiteId: null,
    adPageId: null,
    adTarget: new URLSearchParams(window.location.search).getAll('testdfp'),

    init() {
        if (this.pageIdElement) {
            this.adPageId = this.pageIdElement.getAttribute('data-adv-pageid');
        }

        if (this.siteIdElement) {
            this.adSiteId = this.siteIdElement.getAttribute('data-adv-siteid');
        }

        if (this.targetElement && this.adTarget.length === 0) {
            this.adTarget = JSON.parse(this.targetElement.getAttribute('data-adv-target'));
        }

        if (this.adSiteId !== null && this.adPageId !== null && this.adTarget !== null) {
            this.adsRender();
        }

        window.googletag = window.googletag || { cmd: [] };
        window.googletag.cmd.push(() => {
            window.googletag.setConfig({
                targeting: {
                    page: JSON.parse(this.adPageId),
                    site: this.adSiteId,
                    target: this.adTarget,
                },
            });
        });

        document.addEventListener('ads.refresh', () => {
            this.clearAds();
            this.adsRender();
        });
    },
    adsRender() {
        window.slmadshb = window.slmadshb || {};
        window.slmadshb.que = window.slmadshb.que || [];

        this.formatIdElements.forEach((advertContainer) => {
            window.slmadshb.que.push(() => {
                window.slmadshb.display(advertContainer.id);
            });
        });
    },
    clearAds() {
        this.formatIdElements.forEach((advertContainer) => {
            advertContainer.innerHTML = '';
            advertContainer.style = '';
        });

        Array.from(document.getElementsByClassName('akcelo-loaded')).forEach((element) => {
            element.classList.remove('akcelo-loaded');
        });
    },
};
